
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';

import { LogEntry, LogLevel } from './log.service';

// ****************************************************
// Log Publisher Abstract Class
// NOTE: This class must be located BEFORE
//       all those that extend this class
// ****************************************************
export abstract class LogPublisher {
    location: string;

    abstract log(record: LogEntry): Observable<boolean>
    abstract clear(): Observable<boolean>;
}

// ****************************************************
// Console Logging Class
// ****************************************************
export class LogConsole extends LogPublisher {

    level: LogLevel = AppConfig.settings.logging.logLevel;

    log(entry: LogEntry): Observable<boolean> {
        // Log to console
        console.log(this.level)
        let colors = this.colorLog(this.level)
        console.log("%c" + entry.buildLogString(), `background: ${colors[1]}; color: ${colors[0]}`);

        return of(true);
    }

    clear(): Observable<boolean> {
        console.clear();

        return of(true);
    }

    private colorLog(type) {

        let color = "black";
        let bg = "White";

        switch (type) {
            case 0 || 6:
                color = "Black";
                bg = "White";
                break;
            case 1:
                color = "DodgerBlue";
                bg = "Yellow"
                break;
            case 2:
                color = "Green";
                bg = "Yellow";
                break;
            case 3 || 4:
                color = "Orange";
                bg = "Green";
                break;
            case 5:
                color = "Red";
                bg = "Yellow";
                break
            default:
                color = color;
                bg = bg;
        }

        return [color, bg];
    }
}
